import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {VeranstaltungInfoPage} from './veranstaltung-info.page';
import {EffectsModule} from '@ngrx/effects';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {StoreModule} from '@ngrx/store';
import {reducers} from './veranstaltung-info.reducer';
import {VeranstaltungInfoPageUiEffects} from './veranstaltung-info.effects.ui';
import {VeranstaltungInfoPageWsEffects} from './veranstaltung-info.effects.ws';
import {VeranstaltungInfoPageRoutingModule} from './veranstaltung-info-routing.module';
import {VeranstaltungHomePage} from '../veranstaltung-home/veranstaltung-home.page';
import {VeranstaltungHomePageModule} from '../veranstaltung-home/veranstaltung-home.module';
import {AktionenPageModule} from '../aktionen/aktionen.module';
import {DokumentePageModule} from '../dokumente/dokumente.module';
import {DienstplanPageModule} from '../dienstplan/dienstplan.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        StoreModule.forFeature('VeranstaltungInfoPage', reducers),
        EffectsModule.forFeature([
            VeranstaltungInfoPageUiEffects,
            VeranstaltungInfoPageWsEffects
        ]),
        SopiComponentsModule,
        VeranstaltungInfoPageRoutingModule,
        VeranstaltungHomePageModule,
        AktionenPageModule,
        DokumentePageModule,
        DienstplanPageModule
    ],
    declarations: [VeranstaltungInfoPage],
    entryComponents: [VeranstaltungInfoPage, VeranstaltungHomePage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VeranstaltungInfoModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: VeranstaltungInfoModule
        };
    }
}
